import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api.js';
import { t, getal, wanneer, geleden, huidigeTaal } from '../i18n.js';
import { St } from './Status.jsx';

/**
 * Beheer › Koppelingen › Threat intel (docs/besluiten/threat-intel.md): de openbare lijsten met kwade adressen, wanneer
 * ze het laatst opgehaald zijn en met hoeveel, en wat ZERO er de laatste week mee tegenkwam. Geen sleutel nodig; een
 * lijst die niet lukt, houdt zijn vorige inhoud.
 */
const SOORT = { c2: ['critical', 'C2-servers'], drop: ['serious', 'Kwaadaardige netwerken'], aanvaller: ['warning', 'Aanvallers'] };

export default function ThreatIntel() {
  const client = useQueryClient();
  const q = useQuery({ queryKey: ['intel'], queryFn: api.intel, refetchInterval: 10_000 });
  const [melding, zetMelding] = useState(null);
  if (q.isPending) return <p className="muted">{t('Laden…')}</p>;
  if (q.isError) return <div className="melder rood">{t(q.error.message)}</div>;
  const d = q.data.data;
  const nu = async () => {
    zetMelding(null);
    try { await api.intelVerversen(); zetMelding(t('Ophalen gestart; de tijden hieronder lopen bij.')); } catch (e) { zetMelding(t(e.message)); }
    client.invalidateQueries({ queryKey: ['intel'] });
  };
  return (
    <section className="card">
      <header><h2>{t('Threat intel')}</h2>
        <span className="meta">{d.running ? <St soort="warning">{t('Bezig met ophalen')}</St> : null}</span></header>
      {melding && <div className="melder blauw" style={{ marginBottom: 10 }}>{melding}</div>}
      <table>
        <thead><tr><th>{t('Lijst')}</th><th>{t('Soort')}</th><th style={{ textAlign: 'right' }}>{t('Adressen en reeksen')}</th><th>{t('Opgehaald')}</th></tr></thead>
        <tbody>{d.feeds.map((f) => (
          <tr key={f.id}>
            <td><a href={f.url} target="_blank" rel="noreferrer"><b>{f.naam}</b></a><br /><span className="muted" style={{ fontSize: 12.5 }}>{f.uitleg[huidigeTaal()] ?? f.uitleg.nl}</span></td>
            <td><St soort={SOORT[f.soort][0]}>{t(SOORT[f.soort][1])}</St></td>
            <td className="num" style={{ textAlign: 'right' }}>{getal(f.entries)}</td>
            <td style={{ fontSize: 13 }}>{f.refreshedAt ? <>{geleden(f.refreshedAt)}<br /><span className="muted">{wanneer(f.refreshedAt)}</span></> : <span className="muted">{t('nog niet')}</span>}
              {f.error && <><br /><St soort="critical">{t('Laatste keer mislukt')}</St> <span className="muted">{f.error}</span></>}</td>
          </tr>
        ))}</tbody>
      </table>
      <div className="actions"><button type="button" className="btn primary" disabled={d.running} onClick={nu}>{t('Nu ophalen')}</button></div>
      <dl className="facts" style={{ marginTop: 10 }}>
        <dt>{t('Toegestaan verkeer, 7 dagen')}</dt><dd>{t('{n} verbindingen met {a} adressen op een lijst', { n: getal(d.hits.verbindingen), a: getal(d.hits.adressen) })}</dd>
      </dl>
      <p className="noot">{t('Elke zes uur opgehaald, zonder sleutel. ADTS ZERO kijkt naar geslaagde VPN- en beheerlogins vanaf een adres op een lijst, en naar verkeer dat de firewall toeliet. Dat laatste werkt alleen als de firewall toegestane verbindingen logt (in de toegangsregels: log aan het begin van de verbinding); geweigerd verkeer van een adres op een lijst is geen alert, wel een label op de pagina Firewall.')}</p>
    </section>
  );
}
